import { getReceptorTemplate, Receptor } from 'src/xgenerated/receptor'

export const getLinkerTemplate = (linkerId: string): Receptor => {
  return getReceptorTemplate(linkerId)
}
